import React from 'react'
import { useIntl } from 'react-intl'
import { Button } from '@material-ui/core'
import { LanguageConsumer } from '../../context/LanguageContext'
import { ListingConsumer } from '../../context/ListingContext'
import { FormLoader } from '../Loader/FormLoader'
import GeneralTableWithFilter from '../GeneralTableWithFilter'
import { getStatusIcon } from '../../utils/helpers'
import 'moment/locale/ar-sa'
import Moment from 'react-moment'
import { useStyles } from './Styles'
import packageFormats from '../../configurations/package-format'
import packageTypes from '../../configurations/package-types'
// import requestorTypes from '../../configurations/package-requestor-type'
import packageStatus from '../../configurations/package-status'


const InvoicePackagesList = ({ listingData, locale, openDialog }) => {
  const classes = useStyles()
  const intl = useIntl()

  const columns = [
    {
      name: 'packageId',
      key_name: 'packageId',
      isCustomTextFieldFilter: true,
      label: intl.formatMessage({ id: 'Fields.label.view.Package.packageId' }),
      options: {
        filter: false,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let packageId = listingData[dataIndex]?.packageId
          return !!packageId &&
            <Button size={'large'} variant={'text'} color={'primary'} disableRipple
                    onClick={() => openDialog('show', listingData[dataIndex])}
                    className={classes.modifyLink}>{packageId}</Button>
        }

      }
    },
    {
      name: 'submissionDate',
      key_name: 'submissionDate',
      label: intl.formatMessage({ id: 'Fields.label.view.Package.submissionDate' }),
      options: {
        filter: false,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = listingData[dataIndex]?.submissionDate
          return !!value &&
            <div className={classes.cellDataWrapper}>
              <strong><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                              format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{value}</Moment></strong>
              <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                            format="hh:mm A">{value}</Moment></span>
            </div>
        }
      }
    },
    {
      name: 'format',
      key_name: 'format',
      label: intl.formatMessage({ id: 'Fields.label.view.Package.formatType' }),
      options: {
        filter: false,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let format = packageFormats?.filter(item => item.id?.toString() === listingData[dataIndex]?.format?.toString())
          let type = packageTypes?.filter(item => item.id?.toString() === listingData[dataIndex]?.type?.toString())
          return !!format?.length &&
            <div className={classes.cellDataWrapper}>
              <strong>{format[0].name}</strong>
              {!!type?.length && <span>{type[0][`name_${locale}`]}</span>}
            </div>
        }
      }
    },
    // {
    //   name: 'requestorTypeId',
    //   key_name: 'requestorTypeId',
    //   label: intl.formatMessage({ id: 'Fields.label.view.Package.requestorType' }),
    //   options: {
    //     filter: false,
    //     print: false,
    //     sort: false,
    //     download: false,
    //     customBodyRenderLite: (dataIndex) => {
    //       let requestorType = requestorTypes?.filter(item => item.id?.toString() === listingData[dataIndex].requestorTypeId?.toString())
    //       return !!requestorType?.length && requestorType[0][`name_${locale}`]
    //     }
    //   }
    // },
    {
      name: 'requestorTaxpayerName',
      key_name: 'requestorTaxpayerName',
      label: intl.formatMessage({ id: 'Fields.label.view.Package.requestorTaxpayerName' }),
      options: {
        filter: false,
        display: 'false',
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let requesterTaxpayerName = listingData[dataIndex]?.requestorTaxpayerName || ''
          let requesterTaxpayerTRN = listingData[dataIndex]?.requestorTaxpayerRIN || ''
          return !!requesterTaxpayerName &&
            <div className={classes.cellDataWrapper}>
              <strong>{requesterTaxpayerName}</strong>
              {!!requesterTaxpayerTRN && <span>{requesterTaxpayerTRN}</span>}
            </div>
        }
      }
    },
    {
      name: 'status',
      key_name: 'status',
      label: intl.formatMessage({ id: 'Fields.label.view.Package.status' }),
      options: {
        filter: false,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let status = packageStatus?.filter(item => item.id?.toString() === listingData[dataIndex]?.status?.toString())
          return (
            !!status && !!status.length &&
            <div
              className={classes.statusWrapper + ` ${status[0]['key']?.toString()?.toLowerCase()}`}>
              {getStatusIcon(status[0]['key'])}
              <strong>{status[0][`name_${locale}`]}</strong>
            </div>
          )
        }
      }
    },
    {
      name: 'deletionDate',
      key_name: 'deletionDate',
      label: intl.formatMessage({ id: 'Fields.label.view.Package.deletionDate' }),
      options: {
        filter: false,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = listingData[dataIndex]?.deletionDate
          return !!value && <div className={classes.cellDataWrapper}>
            <Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                    format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{value}</Moment>
          </div>
        }
      }
    }
  ]


  return (
    <LanguageConsumer>
      {({ locale }) => (
        <ListingConsumer>
          {({ listingCount, listingRowsPerPage, listingPage, handleChangeListingPage, handleChangeListingRowsPerPage, listingLoading }) => (
            <div className={'listing-wrapper'}>
              <GeneralTableWithFilter
                columns={columns}
                type={'InvoicePackage'}
                noFilter
                listingData={listingData}
                listingCount={listingCount}
                listingRowsPerPage={listingRowsPerPage}
                listingPage={listingPage}
                handleChangeListingPage={handleChangeListingPage}
                handleChangeListingRowsPerPage={handleChangeListingRowsPerPage}
                locale={locale}
                titleKey={'InvoicePackagesList.PageTitle'}
              />
              {!!listingLoading && <FormLoader loading={true}/>}
            </div>
          )}
        </ListingConsumer>
      )}
    </LanguageConsumer>
  )
}

export default InvoicePackagesList
